import { render, staticRenderFns } from "./HasPermissionTable.vue?vue&type=template&id=65b2eeca&scoped=true"
import script from "./HasPermissionTable.vue?vue&type=script&lang=js"
export * from "./HasPermissionTable.vue?vue&type=script&lang=js"
import style0 from "./HasPermissionTable.vue?vue&type=style&index=0&id=65b2eeca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2eeca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b2eeca')) {
      api.createRecord('65b2eeca', component.options)
    } else {
      api.reload('65b2eeca', component.options)
    }
    module.hot.accept("./HasPermissionTable.vue?vue&type=template&id=65b2eeca&scoped=true", function () {
      api.rerender('65b2eeca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/RolePermissions/HasPermissionTable.vue"
export default component.exports